module.exports = __webpack_public_path__ + "img/sjk1.84bbc61e.webp";